import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  useDataFromSearchParams,
  SearchParamsDataSharingEnum,
} from './searchParamsDataSharing';

const useDashboardScheduleSearchParamsEffect = (
  setSearchQuery: (value: string) => void,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const data = useDataFromSearchParams(searchParams);

  useEffect(() => {
    if (data && data.type === SearchParamsDataSharingEnum.DashboardSchedule) {
      const { term } = data;

      if (term) {
        setSearchQuery(term);
      }

      // Eventually reset search params
      setSearchParams('', { replace: true });
    }
  }, [data, setSearchParams, setSearchQuery]);

  return null;
};

export default useDashboardScheduleSearchParamsEffect;
